import { User } from '../../core/models/classes/user';
import { LoginService } from '../../core/services/login.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConnectionService } from '../../core/services/connection.service';
import { DbCredModel } from '../../core/models/classes/db-cred';
import { UserService } from '../../core/services/user.service';
import { Login } from '../../core/models/classes/login';
import { MatDialog } from '@angular/material/dialog';
import { UserProfileModel } from '../../core/models/classes/user-profile';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {
  userName = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);
  password = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);
  dbName = new FormControl('', [Validators.required, Validators.nullValidator]);
  dbpassword = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);
  host = new FormControl('', [Validators.required, Validators.nullValidator]);
  serviceName = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  oldpassword = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);
  newpassword = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);
  repassword = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  firstName = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  lastName = new FormControl('', [
    Validators.required,
    Validators.nullValidator,
  ]);

  email = new FormControl('', [Validators.required, Validators.nullValidator]);

  loggedInUser: User;
  dbCredential: DbCredModel;
  selectedDbCredential: string;
  schemaList: string[];
  authentificationMessage: string;
  login: Observable<number>;
  result: any;
  hasDbCred: boolean = false;
  hasLoginCred: boolean = true;
  hasPasswordChange: boolean = false;
  IsPasswordForgot: boolean = false;
  schemaAdded: Observable<number>;
  hasAdded: any;
  hasAccess: boolean;
  userProfile: UserProfileModel = new UserProfileModel();
  languague: string;

  constructor(
    private loginService: LoginService,
    private connectionService: ConnectionService,
    private userService: UserService,
    private router: Router,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.loggedInUser = new User();
    this.dbCredential = new DbCredModel();
    this.login = new Observable<number>();
    this.schemaAdded = new Observable<number>();
    this.userProfile = new UserProfileModel();
  }

  ngOnInit(): void {
    if ($localize.locale === 'en-US') {
      this.languague = 'DE';
    } else {
      this.languague = 'EN';
    }
    this.connectionService.availableSchemas().subscribe({
      next: (schema) => {
        this.schemaList = schema;
        this.selectedDbCredential = this.schemaList[0];
      },
      error: (err) => {
        throw Error($localize `Valid License not found`);
      },
    });
  }

  changeLanguage() {
    if (this.languague === 'DE') {
      window.location.replace(
        `${window.location.origin}/adminPortal/de/${window.location.hash}`
      );
    } else {
      window.location.replace(
        `${window.location.origin}/adminPortal/en-US/${window.location.hash}`
      );
    }
  }

  getErrorMessage(): string {
    if (this.userName.hasError('required')) {
      return $localize`Fields cannot be empty`;
    }

    return this.userName.hasError('userName') ? $localize`Invalid User` : '';
  }

  getAuthentificationError(): string {
    return this.authentificationMessage;
  }

  authentificate(): void {
    var isValid = false;
    if(this.userName.value === "" && this.password.value === ""){
      this._snackBar.open($localize `Fields cannot be empty`, '', {
        duration: 3000
      });
    }
    else if(this.userName.value === ""){
      this._snackBar.open($localize `Username cannot be empty`, '', {
        duration: 3000
      });
    }
    else if(this.password.value === ""){
      this._snackBar.open($localize `Password cannot be empty`, '', {
        duration: 3000
      });
    }
    else{ isValid = true; }

    if(isValid){
      this.loggedInUser.name = this.userName.value;
      this.loggedInUser.password = this.password.value;
      var login = new Login();
      let validated = 0;
      login.UserName = this.userName.value;
      login.Password =this.encrypt(this.password.value);
      login.Schema = this.selectedDbCredential;

      this.connectionService
        .authentificateSchema(location.href, this.selectedDbCredential)
        .subscribe({
          next: (data) => {
            validated = data;
            if (validated === 1) {
              localStorage.setItem('schema', this.selectedDbCredential);
              this.connectionService.connectionCheck().subscribe({
                next: (data) => {
                  if (data === true) {
                    this.loginService.validateCredential(login).subscribe({
                      next: (data) => {
                        this.result = data;
                        if ((<any>data).token !== null) {
                          this.loginService.validated = 1;
                          localStorage.setItem('jwt', (<any>data).token);
                           localStorage.setItem('refresh', (<any>data).refreshToken);
                          if (this.result) {
                            this.userService.Auth().subscribe({
                              next: (data) => {
                                localStorage.setItem('loginId', data.toString());
                                this.userService.getUserRole(+data).subscribe({
                                  next: (role) => {
                                    if (role !== 3) {
                                      localStorage.setItem('roleId', role.toString());
                                      this.loggedInUser.id =
                                        +localStorage.getItem('loginId');
                                      this.userService
                                        .defaultPasswordValidate(
                                          this.loggedInUser
                                        )
                                        .subscribe({
                                          next: (data) => {
                                            if (data == true) {
                                              this.hasLoginCred = false;
                                              this.hasPasswordChange = true;
                                            } else {
                                              this.router.navigate(['default']);
                                            }
                                          },
                                        });
                                    } else {
                                      throw Error($localize `Access denied`);
                                    }
                                  },
                                });
                              },
                            });
                          } else {
                            this.authentificationMessage = $localize`Failure`;
                          }
                        }
                        else {
                          throw Error(
                            $localize `Authentification failed. User must have a profile`
                          );
                        }
                      },
                      error: (err) => {
                        this._snackBar.open($localize `Access denied`, '', {
                          duration: 3000
                        });
                      }
                    });
                  }
                  else {
                    throw Error($localize`${this.selectedDbCredential} is not reachable`);
                  }
                },
              });
            }
          },
          error: (err) => {
            throw Error(err.Status);
          },
        });
    }
  }

encrypt(password:string){
  var key = CryptoJS.enc.Utf8.parse('eiVL8sQhJHipvkWZvaU8uUlbu6GGC4aA');
  var iv = CryptoJS.enc.Utf8.parse('6gK6p3VzLFQctO0K');
  const text =password;
  var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

  addDbCred(): void {
    this.dbCredential.DbName = this.dbName.value;
    this.dbCredential.Password = this.dbpassword.value;
    this.dbCredential.Host = this.host.value;
    this.dbCredential.ServiceName = this.serviceName.value;
    this.connectionService
      .addCredential(this.dbCredential)
      .subscribe((data) => {
        this.hasAdded = data;
        if (this.hasAdded === 1) {
          window.location.reload();
          this.switchLogin();
        }
      });
  }

  updatePassword(): void {
    let check = this.fieldValidations();
    if(check){
      if(this.oldpassword.value === "Password1") //first login into AdminPortal of Super user
      {
        if (this.newpassword.value === this.repassword.value) {
          this.loggedInUser.name = this.userName.value;
          this.loggedInUser.password = this.newpassword.value;
          this.resetPassword();
        }
        else {
          throw Error($localize`Password mismatch`);
        }
      }
      else if(this.hasPasswordChange){
        if (this.newpassword.value === this.repassword.value) {
          this.loggedInUser.name = this.userName.value;
          this.loggedInUser.password = this.newpassword.value;
          this.resetPassword();
        }
        else {
          throw Error($localize`Password mismatch`);
        }
      }
      else{
        throw Error($localize`Old Password incorrect`);
      }
    }
  }

  fieldValidations(): boolean{
    var isValid = false;
    if(this.oldpassword.value === "" && this.newpassword.value === "" && this.repassword.value === ""){
      this._snackBar.open($localize `Fields cannot be empty`, '', {
        duration: 3000
      });
    }
    else if(this.oldpassword.value === ""){
      this._snackBar.open($localize `Enter old password`, '', {
        duration: 3000
      });
    }
    else if(this.newpassword.value === ""){
      this._snackBar.open($localize `Enter new password`, '', {
        duration: 3000
      });
    }
    else if(this.repassword.value === ""){
      this._snackBar.open($localize `Confirm new password`, '', {
        duration: 3000
      });
    }
    else{ isValid = true; }

    return isValid;
  }

  resetPassword(){
    const id = localStorage.getItem('loginId');
    this.userService.updatePassword(+id, this.loggedInUser).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this.hasLoginCred = true;
          this.hasPasswordChange = false;
          this._snackBar.open($localize `Password reset successful`, '', {
            duration: 3000
          });
        }
        else {
          this.authentificationMessage = data.statusText;
          this._snackBar.open($localize `Password reset failed`, '', {
            duration: 3000
          });
        }
      },
      error: (err) => {
        this.authentificationMessage = err;
        {
          throw Error(err.Status);
        }
      },
    });
  }

  switchLogin(): void {
    this.hasDbCred = !this.hasDbCred;
    this.hasLoginCred = !this.hasLoginCred;
  }

  forgotPasswordSwitch() {
    this.hasLoginCred = !this.hasLoginCred;
    this.IsPasswordForgot = !this.IsPasswordForgot;
  }

  forgotPassword() {
    this.userProfile.firstName = this.firstName.value;
    this.userProfile.lastName = this.lastName.value;
    this.userProfile.email = this.email.value;

    this.userService.resetPassword(this.userProfile).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this._snackBar.open($localize `Password reset request sent. Check your email.`, '', {
            duration: 3000
          });
          this.forgotPasswordSwitch();
        }
      },
      error: (err) => {
        {
          throw Error(err.Status);
        }
      },
    });
  }
}
